import styled from 'styled-components/macro';
import { Button } from '../..';

export const DangerButton = styled(Button)`
  background-color: #cf4845;
  border: 1px solid #cf4845;
  &:hover {
    border: 1px solid #cf4845;
  }
`;

export const Title = styled.div`
  color: #333;
  font-size: 21px;
  line-height: 24px;
  margin-bottom: 10px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  & > * {
    margin-left: 11px;
  }
`;

export const Container = styled.div`
  margin-top: 0px;
`;
